interface SellerMetricsInterface {
    id: string;
    totalOrders: number;
    totalEarningsInPaisa: number;
    seller: string;
}

export class SellerMetrics implements SellerMetricsInterface {
    id: string;
    totalEarningsInPaisa: number;
    totalOrders: number;
    seller: string;

    constructor(jsonData: any) {
        this.id = jsonData._id
        this.totalEarningsInPaisa = jsonData.totalEarningsInPaisa
        this.totalOrders = jsonData.totalOrders
        this.seller = jsonData.seller
    }

}